import { render } from "./OilResultTable.vue?vue&type=template&id=9a610ede&ts=true"
import script from "./OilResultTable.vue?vue&type=script&lang=ts"
export * from "./OilResultTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__